/**
 * Tagesstand der KIAN-Schreibhilfen — steht neben jedem KIAN-Knopf.
 *
 * „Kostet Geld" ist sonst unsichtbar: der Klick fühlt sich gratis an. Hier stehen
 * Verbrauch, Kontingent und die geschätzten Kosten des Tages, damit niemand blind
 * verbraucht. Die Zahlen kommen aus der LLM-Telemetrie (llm_metrics), nicht aus
 * einem zweiten Zähler, der auseinanderlaufen könnte.
 */
import { Text, Tooltip } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function KianAssistUsageHint() {
  const { data } = useQuery({
    queryKey: ['kian-assist-usage'],
    queryFn: () => api.getKianAssistUsage(),
    staleTime: 30 * 1000,
  });
  if (!data) return null;
  const exhausted = data.remaining <= 0;
  return (
    <Tooltip
      label={`KIAN-Schreibhilfen (ITIL-Format, Ticket-Aufnahme, Kommentar-Entwurf): ${data.used} von ${data.limit} heute, geschätzte Kosten ${formatEur(data.costEurToday)}. Das Kontingent steht morgen früh wieder zur Verfügung.`}
      withArrow
      multiline
      w={280}
    >
      <Text size="xs" c={exhausted ? 'red' : 'dimmed'} style={{ whiteSpace: 'nowrap' }}>
        {data.used}/{data.limit} · {formatEur(data.costEurToday)}
      </Text>
    </Tooltip>
  );
}

/** Beträge unter einem Cent sind sonst alle „0,00 €" — dann lieber in Cent. */
export function formatEur(value: number): string {
  if (value > 0 && value < 0.01) return `${(value * 100).toFixed(1)} ct`;
  return `${value.toFixed(2)} €`.replace('.', ',');
}

